module.exports = __webpack_public_path__ + "static/media/1@2x.1289e04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/1@2x.png
// module id = 1515
// module chunks = 0